import styled, { css } from 'styled-components';

import { Input } from '@gympass/yoga';

import { InputProps } from './types';

const baseInputStyles = css`
  background-color: ${({ theme }) => theme.yoga.colors.white};
  :disabled {
    color: ${({ theme }) => theme.yoga.colors.textDisabled};
  }
`;
const errorInputStyles = css`
  fieldset {
    border-color: ${({ theme }) => theme.yoga.colors.error};
    color: ${({ theme }) => theme.yoga.colors.error} !important;

    label {
      color: ${({ theme }) => theme.yoga.colors.error} !important;
    }

    > * {
      color: ${({ theme }) => theme.yoga.colors.error} !important;
    }
  }

  > div > div {
    color: ${({ theme }) => theme.yoga.colors.error} !important;
  }
`;

export const InputContainer = styled.div<InputProps>`
  ${props => props.error && errorInputStyles};
`;

export const StyledInput = styled(Input)`
  ${baseInputStyles};
  ${props => props.error && errorInputStyles};
`;

export const StyledEmail = styled(Input.Email)`
  ${baseInputStyles};
  ${props => props.error && errorInputStyles};
`;

export const StyledTel = styled(Input.Tel)`
  ${baseInputStyles};
  ${props => props.error && errorInputStyles};
`;

export const StyledFile = styled.input`
  ${baseInputStyles};
`;

export const StyledPassword = styled(Input.Password)`
  ${baseInputStyles};
  ${props => props.error && errorInputStyles};
`;

export const StyledNumber = styled(Input.Number)`
  ${baseInputStyles};
  ${props => props.error && errorInputStyles};
`;
